<template lang="pug">
  v-dialog(v-model='dialog' scrollable persistent content-class="flex xs12 sm8")
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        span.headline {{ formTitle }}
      v-divider
      v-card-text
        v-row(dense)
          v-flex(xs12='xs12')
            template
              v-stepper(v-model='e6')
                v-stepper-header(class="stepper-header" style="height:initial")
                  v-stepper-step( :complete="e6 > 1" step="1" style="weidth: 25%") Detalles
                  v-divider.divider-none
                  v-stepper-step( :complete="e6 > 2" step="2" style="weidth: 25%") Costos
                  v-divider.divider-none
                  v-stepper-step( :complete="e6 > 3" step="3" style="weidth: 25%") medidas
                  v-divider.divider-none
                  v-stepper-step( :complete="e6 > 4" step="4" style="weidth: 25%") Segmentación
                  v-divider.divider-none
                  v-stepper-step( :complete="e6 > 5" step="5" style="weidth: 25%") Seriales
                  v-divider.divider-none
                  v-stepper-step( step="6" style="weidth: 25%") Imagen
                v-stepper-items
                  v-stepper-content.pa-2(step='1')
                    v-row(dense v-if='config.empaque && config.empaque.valor')
                      v-col
                        v-row(dense)
                          v-col(cols='12' sm='12' md='6')#nombreP
                            v-text-field(v-model='form.nombre', dense, outlined, :readonly='read', id="codProducto", label='*Codigo', v-uppercase)
                          v-col(cols='12' sm='12' md='6')#descripcionP
                            v-text-field(v-model='form.descripcion', dense, outlined, :readonly='read', id="descProducto", label='*Descripcion', v-uppercase)
                        v-row(dense)
                          v-col(cols='12' sm='12' md='4')#unidadP
                            v-autocomplete(autocomplete="off" :readonly='read' :menu-props="{closeOnContentClick: true}" v-model='form.unidadMedida' dense outlined id="unidadMedidaProducto" :items='undidadesVenta' label='*Unidad de venta principal')
                              template(v-slot:prepend-item)
                                v-list(dense)
                                  v-list-item(@click='unidadVentaM = true')
                                    v-list-item-avatar(color='grey_1')
                                      v-btn.mx-2(fab dark x-small color='success')
                                        v-icon(dark small) mdi-plus
                                    v-list-item-content
                                      v-list-item-title
                                        | Agregar Unidad de venta
                            unidad-venta-m( :dialog='unidadVentaM', :editedIndex='-1', @close='unidadVentaM = false', @save='listarUnidadesVenta')
                          v-col(cols='12' sm='12' md='4')#cantidadPreP
                            v-text-field(type='number' :readonly='read' v-model.number='form.stock' dense outlined label='Stock')
                          v-col(cols='12' sm='12' md='4')#presentacionP
                            v-autocomplete(autocomplete="off", :readonly='read', :menu-props="{closeOnContentClick: true}", v-model='form.presentacion' dense, outlined,
                            :items="presentaciones", label="Presentacion")
                              template(v-slot:prepend-item)
                                v-list(dense)
                                  v-list-item(@click='presentacionM = true')
                                    v-list-item-avatar(color='grey_1')
                                      v-btn.mx-2(fab dark x-small color='success')
                                        v-icon(dark small) mdi-plus
                                    v-list-item-content
                                      v-list-item-title
                                        | Agregar Presentacion
                          presentacion-prod-m( v-model='form.presentacion' :dialog='presentacionM', :editedIndex='-1', @close='presentacionM = false', @save='listarPresentaciones')
                          //- v-col(cols='12' sm='12' md='4')#cantidadPreP
                          //-   v-text-field(type='number' :readonly='read' v-model.number='form.cantidadUnidadMedida' dense outlined label='Cantidad de presentacion')
                        v-row(dense)
                          v-col(cols='12' sm='12' md='6')
                            v-btn(color='success' :readonly='read' dark @click='dialogShow = true') Unidades de ventas secundarias
                    v-row(dense v-else)
                      v-col(cols='12' sm='12' md='4')#nombreP
                        v-text-field(v-model='form.nombre' :readonly='read' dense outlined id="nombreProducto" label='*Codigo')
                      v-col(cols='12' sm='12' md='4')#descripcionP
                        v-text-field(v-model='form.descripcion' :readonly='read' dense outlined id="descripcionProducto" label='*Descripcion')
                      v-col(cols='12' sm='12' md='4')#unidadP
                        v-autocomplete(autocomplete="off" :readonly='read' :menu-props="{closeOnContentClick: true}" v-model='form.unidadMedida' dense outlined id="unidadMedidaProducto" :items='undidadesVenta' label='*Unidad de Venta')
                          template(v-slot:prepend-item)
                            v-list(dense)
                              v-list-item(@click='unidadVentaM = true')
                                v-list-item-avatar(color='grey_1')
                                  v-btn.mx-2(fab dark x-small color='success')
                                    v-icon(dark small) mdi-plus
                                v-list-item-content
                                  v-list-item-title
                                    | Agregar Unidad de venta                    
                    v-row(dense v-if="editedIndex === -1 && (config.portafolio && config.portafolio.valor)")
                      v-col(cols='12', sm='12', md='4')#portafolioP
                        v-autocomplete(autocomplete="off" :readonly='read' :menu-props="{closeOnContentClick: true}" dense outlined v-model='form.codPortafolio'
                        :items='idPortafolioArray' label='*Portafolio' @change="portafolioSeleccionado")
                          template(v-slot:prepend-item v-if="validarCrearPortafolio()")
                            v-list(dense)
                              v-list-item( @click='port = true')
                                v-list-item-avatar(color='grey_1')
                                  v-btn.mx-2(fab dark x-small color='success')
                                    v-icon(dark small) mdi-plus
                                v-list-item-content
                                  v-list-item-title
                                    | Agregar Portafolio
                        PortafolioM(:dialog='port' :editedIndex='-1' @close='port = false' @save='listarPortafolios')
                      v-col(cols='12' md='4')#almacenP
                        v-autocomplete(autocomplete="off" :readonly='read' :menu-props="{closeOnContentClick: true}" outlined dense v-model='selecAlma'
                        @change="almacenSeleccionado" :items="idAlmacenArray" label='*Almacen')
                          template(v-slot:prepend-item v-if="validarCrearAlmacen()")
                            v-list(dense)
                              v-list-item( @click='alm = true')
                                v-list-item-avatar(color='grey_1')
                                  v-btn.mx-2(fab dark x-small color='success')
                                    v-icon(dark small) mdi-plus
                                v-list-item-content
                                  v-list-item-title
                                    | Agregar Almacen
                        AlmacenM(:dialog='alm' :editedIndex='-1' @close='alm = false' @save='listarAlmacenes')
                      v-col(cols='12' md='4')#ivaP
                        v-select(dense outlined :readonly='read' v-model='selecIva' :items="idIVAArray" @change= "IVASeleccionado" label='*IVA')
                    v-row(dense v-else-if="editedIndex === -1 && !config.portafolio")
                      v-col(cols='12' md='6')#almacenP
                        v-autocomplete(autocomplete="off" :readonly='read' :menu-props="{closeOnContentClick: true}" outlined dense v-model='selecAlma'
                        @change="almacenSeleccionado" :items="idAlmacenArray" label='*Almacen')
                          template(v-slot:prepend-item v-if="validarCrearAlmacen()")
                            v-list(dense)
                              v-list-item( @click='alm = true')
                                v-list-item-avatar(color='grey_1')
                                  v-btn.mx-2(fab dark x-small color='success')
                                    v-icon(dark small) mdi-plus
                                v-list-item-content
                                  v-list-item-title
                                    | Agregar Almacen
                        AlmacenM(:dialog='alm' :editedIndex='-1' @close='alm = false' @save='listarAlmacenes')
                      v-col(cols='12' md='6')#ivaP
                        v-select(dense outlined :readonly='read' v-model='selecIva' :items="idIVAArray" @change= "IVASeleccionado" label='*IVA')
                    v-flex(class="btn-flex d-flex flex-wrap")
                      v-btn(color='success' dark @click='validarSteps()')
                        span Continuar
                  v-stepper-content.pa-2(step='2')
                    v-row(dense)
                      v-col(cols='6' sm='4')
                        v-switch(dense color='success' :readonly='read' v-model='dolarCosto' label='Dolar' )
                      v-col(cols='6' sm='4')
                        v-switch(dense color='success' :readonly='read' v-model='bsCosto' label='Bs' )
                    v-row(dense v-if='config.stock && config.stock.valor')
                      v-col(v-if="bsCosto" cols='12' md='6')#costoP
                        v-text-field(outlined dense :readonly='read' v-model.number='form.costo' @keyup="calculos(form.costo, porcentaje)" type='number' min="0" label='Costo(U) Bs' prefix="Bs")
                      v-col(v-else cols='12' md='6')#costoP2
                        v-text-field(outlined dense :readonly='read' v-model.number='form.costoDolar' type='number' min="0" @keyup="calculos(form.costoDolar, porcentaje)" label='Costo(U) $' prefix="$")
                      v-col(cols='12' sm='12' md='6')#cantidadMedidaP
                        v-text-field(outlined v-model='form.stock' :readonly='read' type='number' min="0" dense label='*Cantidad Inicial' hint="El valor debe ser Positivo")
                    v-row(dense v-else)
                      v-col(cols='12' md='6')#costoP
                        v-text-field(outlined dense :readonly='read' v-model.number="form.costo" type='number' min="0" label='*Costo Producto' hint="El costo del producto en Bs" prefix="Bs")
                    v-row(dense v-if="editedIndex === -1 && (config.stockMin && config.stockMin.valor) && (config.peso && config.peso.valor)")
                      v-col(cols='12' md='4')#utilidadP
                        v-text-field(dense outlined :readonly='read' v-model.number='porcentaje' type='number' min="0" label='% Utilidad')
                      v-col(cols='12' sm='12' md='4')#stockMinP
                        v-text-field(v-model='form.stockMin' :readonly='read' type='number' min="0" dense outlined label='*Stock Minimo' hint="El valor debe ser Positivo")
                      v-col(cols='12' md='4')#pesoP1
                        v-text-field(v-model='form.peso' :readonly='read' type='number' min="0" dense outlined label='Peso' hint='El peso esta en base a Kg.' suffix="Kg")
                    v-row(dense v-else-if="editedIndex === -1 && !config.stockMin && (config.peso && config.peso.valor)")
                      v-col(cols='12' md='6')#utilidadP
                        v-text-field(dense outlined :readonly='read' v-model.number='porcentaje' type='number' min="0" label='% Utilidad')
                      v-col(cols='12' md='6')#pesoP2
                        v-text-field(v-model='form.peso' :readonly='read' type='number' min="0" dense outlined label='Peso' hint='El peso esta en base a Kg.' suffix="Kg")
                    v-row(dense v-else-if='editedIndex === -1 && !config.peso && (config.stockMin && config.stockMin.valor)')
                      v-col(cols='12' md='6')#utilidadP
                        v-text-field(dense outlined :readonly='read' v-model.number='porcentaje' type='number' min="0" label='% Utilidad')
                      v-col(cols='12' sm='12' md='6')#stockMinP
                        v-text-field(v-model='form.stockMin' :readonly='read' type='number' min="0" dense outlined label='*Stock Minimo' hint="El valor debe ser Positivo")
                    v-row(dense v-else-if='editedIndex === -1 && !config.peso && !config.stockMin')
                      v-col(cols='12' md='6')#utilidadP
                        v-text-field(dense outlined :readonly='read' v-model.number='porcentaje' type='number' min="0" label='% Utilidad')
                    v-row(dense v-else-if="editedIndex !== -1")
                      v-col(cols='12' sm='12' md='6' v-if='(config.stockMin && config.stockMin.valor)')#stockMinP
                        v-text-field(v-model='form.stockMin' :readonly='read' type='number' min="0" dense outlined label='*Stock Minimo' hint="El valor debe ser Positivo")
                      v-col(cols='12' md='6' v-if='config.peso && config.peso.valor')#PesoP3
                        v-text-field(v-model='form.peso' :readonly='read' type='number' min="0" dense outlined label='Peso' hint='El peso esta en base a Kg.' suffix="Kg")
                    h4(v-if="editedIndex === -1") Moneda base del producto
                    v-row(dense v-if="editedIndex === -1")
                      v-col(cols='12' md='4')
                        v-row(dense)
                          v-col(cols='6' md='6')
                            v-switch(dense color='success' v-model='dolar' label='Dolar' )
                          v-col(cols='6' md='6')
                            v-switch(dense color='success' v-model='bs' label='Bs' )
                      v-col(cols='12' md='4')#bolivarP
                        v-text-field(outlined dense :readonly="!bs" v-model.number='form.precioBs' type='number' min="0" label='Precio Bs' hint="El precio del producto se calcula en base a Costo x Utilidad(%)" prefix="Bs")
                      v-col(cols='12' md='4')#dolarP
                        v-text-field(outlined dense :readonly="!dolar" v-model.number="form.precio" type='number' min="0" label='*Precio Dolar' prefix="$")
                        h4(v-if="tasa <= 0") actualice la tasa!

                    v-flex(class="btn-flex d-flex flex-wrap")
                      v-btn(color='error' dark @click='e6 = 1' class="mr-5") Atras
                      v-btn(color='success' dark @click='validarSteps()')
                        | Continuar
                  v-stepper-content.pa-2(step='3')
                    v-row(dense)
                      v-col(cols='12' sm='12' md='6')#altoP
                        v-text-field(v-model.number='form.alto' :readonly='read' type='number' min="0" id="alto" dense outlined label='Alto' suffix="cm" hint="El valor debe ser Positivo")
                      v-col(cols='12' md='6')#anchoP
                        v-text-field(outlined :readonly='read' dense v-model.number="form.ancho" id="ancho" type='number' min="0" label='Ancho' suffix="cm" hint="El valor debe ser Positivo")
                    v-row(dense)
                      v-col(cols='12' md='6')#largoP
                        v-text-field(outlined dense :readonly='read' v-model.number="form.largo" type='number' id="largo" min="0" label='Largo' suffix="cm" hint="El valor debe ser Positivo")
                      v-col(cols='12' md='6')#volumenP
                        v-text-field(outlined :readonly='read' dense readonly v-model.number="form.volumen" id="volumen" type='number' min="0" label='Volúmen' suffix="cm3")
                    v-flex(class="btn-flex d-flex flex-wrap")
                      v-btn(color='error' dark @click='e6 = 2' class="mr-5") Atras
                      v-btn(color='success' dark @click='validarSteps()')
                        | Continuar
                  v-stepper-content.pa-2(step='4')
                    v-row(dense v-if='config.idLinea && config.idLinea.valor')
                      v-col(cols='12' sm='12' md='6')#lineaP
                        v-autocomplete(autocomplete="off", :readonly='read', dense outlined :menu-props="{closeOnContentClick: true}" v-model='form.idLinea' id = "lineaProducto" :items='idLineaArray' label='Categoria' @change="lineaSeleccionada")
                          template(v-slot:prepend-item v-if="validarCrearLinea()")
                            v-list(dense)
                              v-list-item( @click='lineaM = true')
                                v-list-item-avatar(color='grey_1')
                                  v-btn.mx-2(fab dark x-small color='success')
                                    v-icon(dark small) mdi-plus
                                v-list-item-content
                                  v-list-item-title
                                    | Agregar Categoria
                        LineaM(:dialog='lineaM' :editedIndex='-1' @close='lineaM = false' @save='listarLineas')
                      v-col(cols='12' sm='12' md='6')#subLineaP
                        v-autocomplete(autocomplete="off", :readonly='read', dense outlined v-model='form.sublinea' id = "sublineaProducto" :items='sublineaArray' label='SubCategoria' persistent-hint hint="Seleccione una Categoria" )
                    v-row(dense v-if='config.idFabricante && config.idFabricante.valor')
                      v-col(cols='12' sm='12' md='6')#fabricanteP
                        v-autocomplete(autocomplete="off", :readonly='read' dense outlined :menu-props="{closeOnContentClick: true}" v-model='form.idFabricante' id = "fabricanteProducto" :items='idFabricanteArray' label='Fabricante' @change='fabricanteSeleccionado')
                          template(v-slot:prepend-item v-if="validarCrearFabricante()")
                            v-list(dense)
                              v-list-item( @click='fab = true')
                                v-list-item-avatar(color='grey_1')
                                  v-btn.mx-2(fab dark x-small color='success')
                                    v-icon(dark small) mdi-plus
                                v-list-item-content
                                  v-list-item-title
                                    | Agregar Fabricante
                        FabricanteM(:dialog='fab' :editedIndex='-1' @close='fab = false' @save='listarFabricantes')
                      v-col(cols='12' sm='12' md='6')#marcaP
                          v-autocomplete(autocomplete="off" :readonly='read' dense outlined :menu-props="{closeOnContentClick: true}" v-model='form.idMarca' id = "marcaProducto" :items='idMarcaArray' label='Marca' persistent-hint hint="Seleccione un Fabricante")
                    v-flex(class="btn-flex d-flex flex-wrap")
                      v-btn(v-if='config.medidas && config.medidas.valor' color='error' dark @click='e6 = 3' class="mr-5") Atras
                      v-btn(v-else color='error' dark @click='e6 = 2' class="mr-5") Atras
                      v-btn(color='success' dark @click='validarSteps()')
                        | Continuar
                  v-stepper-content.pa-2(step='5')
                    h4(style='color: black') Seriales del Producto
                    v-row.ma-5(dense)
                      v-flex(xs12 sm12 md12 style='display: flex;justify-content: center;')
                        v-btn(class="btn-seriales" color='primary_2' dark @click='modalSeriales') Agregar Seriales
                    v-flex(class="btn-flex d-flex flex-wrap")
                      v-btn(v-if='(config.idLinea && config.idLinea.valor) || (config.idFabricante && config.idFabricante.valor)' color='error' dark @click='e6 = 4' class="mr-5") Atras
                      v-btn(v-else-if='(!config.idLinea && !config.idFabricante) && (config.medidas && config.medidas.valor)' color='error' dark @click='e6 = 3' class="mr-5") Atras
                      v-btn(v-else-if='(!config.idLinea && !config.idFabricante) && !config.medidas' color='error' dark @click='e6 = 2' class="mr-5") Atras
                      v-btn(color='success' dark @click='validarSteps()')
                        | Continuar
                  v-stepper-content.pa-2(step='6')
                    h4(style='color: black') Imagen del Producto
                    v-row.ma-5(dense)
                      v-col(cols='12' sm='12' md='12')
                        v-flex(xs12 sm12 md12 style='display: flex;justify-content: center;' class="img-pro")
                          img(:src='ruta + img' v-if='img && !form.imagen.imageUrl' style='width:310px;height:auto')
                          img(:src='form.imagen.imageUrl' v-if='form.imagen.imageUrl' style='width:310px;height:auto')
                      p
                      v-col(cols='12' sm='12' md='12')
                        v-text-field(style='height: 56px;margin: 0px 0px 10px;' v-if="!read" rounded outlined label='Seleccione la imagen' @click='pickFile' v-model='img' prepend-inner-icon='attach_file')
                        input(type='file' style='display: none' ref='image' accept='image/*' @change='onFilePicked')
                    v-flex(class="btn-flex d-flex flex-wrap")
                      v-btn(color='error' dark @click='e6 = 5' class="mr-5") Atras
                      v-btn(v-if="!read" color='success' dark @click='validarSteps()')
                        v-icon mdi-content-save
                        | Guardar
      v-card-actions
        SerialM2(:dialog='ser' :FormPadre='seriales' :editedIndex='editedIndex' :editedIndexPro='editedIndex' @close='ser = false' @saveSerial='guardarSerialesProducto' :read="read" :pro="pro" :serialesAlm='seriales' :codigo='form.nombre')
        Serial2(:dialog='ser2' :FormPadre='seriales' @close='ser2 = false' @save='listarSeriales' @edited='listarSeriales' :read="read" :pro="pro" @actSer='listarSeriales' :idPro='form._id' :codigo='form.nombre')
        v-spacer
        v-btn(color='error' small dark @click='close')
          v-icon mdi-close
          | Cancelar
    v-dialog(v-model='dialogShow' persistent content-class="flex xs12 sm6 md6")
      v-card(color='grey_1')
        v-app-bar(dark color='primary')
          v-toolbar-title.headline Almacenamiento
        v-card-text
          v-row(dense)
            v-col(cols='12' v-if="!read")
              v-card(color='white')
                v-card-text
                  v-row(dense v-if="!read")
                    v-col(cols='12' sm='12' md='8')
                      v-autocomplete(autocomplete="off" v-if='!empaq' dense outlined :menu-props="{closeOnContentClick: true}" v-model='formEmpaque.presentacion' id='presentacion' :items='EmpaquesDefault' label='Presentación')
                        template(v-slot:prepend-item)
                          v-list(dense)
                            v-list-item( @click='empaq = true')
                              v-list-item-avatar(color='grey_1')
                                v-btn.mx-2(fab dark x-small color='success')
                                  v-icon(dark small) mdi-plus
                              v-list-item-content
                                v-list-item-title
                                  | Agregar Presentacion
                      v-text-field(v-else='empaq' dense outlined v-model='formEmpaque.presentacion' persistent-hint hint='Indique la Presentación del Producto' label='Presentación')
                    v-col(cols='12' sm='12' md='4')#cantidadP
                      v-text-field(dense outlined min=0 type='number' v-model='formEmpaque.cantidad' label='Cantidad' v-on:blur='validarCantidadEmpaque')
                  v-row(dense v-if="!read")
                    v-col(v-if='editedIndexEmpaque > -1' cols='12' sm='12' md='8' class='d-flex justify-end')
                      v-btn(color='error' small dark @click='resetEmpaque') Cancelar
                    v-col(v-if='editedIndexEmpaque > -1' cols='12' sm='12' md='4' class='d-flex justify-end')
                      v-btn( color='success' small dark @click='saveEmpaque') Editar Empaque
                    v-col(v-else cols='12' sm='12' md='12' class='d-flex justify-end')
                      v-btn( color='success' small dark @click='saveEmpaque') Agregar Empaque
            v-col(cols='12')
              v-card(color='white')
                v-card-subtitle.title(style='color: black') Empaques agregados
                  v-card-text
                    v-row(dense)
                      v-col(cols='12' sm='12' md='12')
                        v-data-table.elevation-1(:headers='headersEmpaq' dense :items='form.empaques')
                          template(v-slot:item.action='{ item }')
                            v-tooltip(bottom='')
                              template(v-slot:activator='{ on }')
                                v-icon.mr-2(v-if="!read" color='warning' @click='editEmpaque(item)' v-on="on") mdi-pencil
                              | Editar
                            v-tooltip(bottom='')
                              template(v-slot:activator='{ on }')
                                v-icon(v-if="!read" color='error' @click='deleteEmpaque(item)' v-on="on") mdi-delete
                              | Eliminar
                          template(v-slot:no-data)
                            h3 No hay Empaques cargados
        v-card-actions
          v-spacer
          v-btn(color='error' small dark @click='closeShow')
            v-icon mdi-close
            | Salir
          v-btn(v-if="form.empaques.length > 0 && !read" color='success' small dark @click='closeShow')
            v-icon mdi-content-save
            | Confirmar
</template>

<script>
import Api from '@/services/methods'
// import '../../assets/scss/estilosProducto.scss'
import FabricanteM from './FabricanteM'
import MarcaM from './MarcaM'
import PortafolioM from './PortafolioM'
import LineaM from './LineaM'
import AlmacenM from './AlmacenM'
import PresentacionProdM from './PresentacionProdM'
import UnidadVentaM from './UnidadVentaM'
import SerialM2 from './SerialM2'
import Serial2 from '../../views/Serial2'
import { EventBus } from '../../Events'
import { server, port } from '../../services/environment'
export default {
  props: ['dialog', 'editedIndex', 'FormPadre', 'read'],
  name: 'ProductoM',
  data: () => ({
    presentaciones: [],
    undidadesVenta: [],
    permisosMarca: {},
    permisosPortafolio: {},
    permisosLinea: {},
    permisosAlmacen: {},
    permisosFabricante: {},
    e6: 1,
    config: null,
    tasa: 0,
    editedIndexEmpaque: -1,
    productos: [],
    dialogShow: false,
    empaq: false,
    emp: false,
    fab: false,
    alm: false,
    ser: false,
    ser2: false,
    marcaM: false,
    lineaM: false,
    presentacionM: false,
    unidadVentaM: false,
    dolar: false,
    bs: true,
    dolarCosto: false,
    bsCosto: true,
    seriales: [],
    port: false,
    pro: true,
    ruta: server + ':' + port,
    selecAlma: '',
    selecIva: '',
    fabricante: [],
    idFabricanteArray: [],
    marca: [],
    idMarcaArray: [],
    linea: [],
    idLineaArray: [],
    sublineaArray: [],
    img: '',
    // medidasArray: ['PAR', 'OTRO', 'UNIDAD'],
    EmpaquesDefault: ['BULTO', 'CAJA'],
    medidasArray: ['BULTOS 12', 'BULTOS 18', 'BULTO', 'CAJA', 'DOCENA', 'GALON', 'GRUESA', 'KILOGRAMO', 'LITRO', 'MILLAR',
                   'METROS', 'OTRO', 'PAQUETE', 'PAR', 'PIE', 'RESMA', 'ROLLO', 'UNIDAD', 'DISPLAY', 'BLISTER', 'TIRAS', 'RISTRA'],
    headersEmpaq: [
      { text: 'Presentacion', value: 'presentacion', align: 'center' },
      { text: 'Cantidad', value: 'cantidad', align: 'center' },
      { text: 'Acciones', value: 'action', align: 'center', sortable: false }
    ],
    form: {
      _id: '',
      costo: 0,
      costoDolar: 0,
      precio: 0,
      precioBs: 0,
      moneda: 'Bs',
      codPortafolio: null,
      nombre: '',
      descripcion: '',
      unidadMedida: '',
      stock: 0,
      idMarca: null,
      idLinea: null,
      idFabricante: null,
      sublinea: null,
      peso: 0,
      stockMin: 0,
      presentacion: null,
      cantidadUnidadMedida: null,
      imagen: {
        imageName: '',
        imageUrl: '',
        imageFile: ''
      },
      empaques: [],
      seriales: [],
      // upc: "",
      // pesoMerma: 0,
      volumen: 0,
      alto: 0,
      ancho: 0,
      largo: 0
      // medidaEmpaque: 0,
    },
    defaultForm: {
      _id: '',
      costo: 0,
      costoDolar: 0,
      precio: 0,
      precioBs: 0,
      moneda: 'Bs',
      codPortafolio: null,
      nombre: '',
      descripcion: '',
      unidadMedida: '',
      stockMin: 0,
      stock: 0,
      idMarca: null,
      idFabricante: null,
      idLinea: null,
      sublinea: null,
      peso: 0,
      presentacion: null,
      cantidadUnidadMedida: null,
      imagen: {
        imageName: '',
        imageUrl: '',
        imageFile: ''
      },
      empaques: [],
      seriales: [],
      // upc: "",
      // pesoMerma: 0,
      volumen: 0,
      alto: 0,
      ancho: 0,
      largo: 0
      // medidaEmpaque: 0,
    },
    portafolio: [],
    idPortafolioArray: [],
    iva: [],
    idIVAArray: [],
    almacenes: [],
    idAlmacenArray: [],
    porcentaje: 0,
    formEmpaque: {
      presentacion: '',
      cantidad: 0
    },
    defaultEmpaque: {
      presentacion: '',
      cantidad: 0
    }
  }),
  components: {
    FabricanteM,
    MarcaM,
    LineaM,
    AlmacenM,
    PortafolioM,
    SerialM2,
    Serial2,
    PresentacionProdM,
    UnidadVentaM
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Nuevo Producto'
        : this.read
          ? 'Información del Producto'
          : 'Modificar Producto'
    }
  },

  watch: {
    FormPadre (val) {
      // formulario que llega del padre, para editar y ver
      if (Object.keys(val).length !== 0) {
        this.e6 = 1
        Object.keys(this.form).map(key => {
          if (val[key]) this.form[key] = val[key]
        })
        if (val.idFabricante) {
          this.fabricanteSeleccionado(val.idFabricante)
        }
        if (val.idLinea) {
          this.lineaSeleccionada(val.idLinea)
        }
        if (val.unidadMedida?._id) this.form.unidadMedida = val.unidadMedida._id
        this.form.imagen = {
          imageName: '',
          imageUrl: '',
          imageFile: ''
        }
        if (val.logo) {
          this.img = val.logo
        }
        console.log('ITEM 2 ', val)
        console.log('ITEM 3 ', this.img)
        // this.form._id = val._id;
        // this.form.idFabricante = val.idFabricante._id;
        // this.form.idMarca = val.idMarca._id;
        // this.form.idLinea = val.idLinea._id;
      }
    },
    'porcentaje': function (val) {
      if (this.porcentaje >= 0) {
        if (this.bsCosto) {
          this.calculos(this.form.costo, val)
        } else {
          this.calculos(this.form.costoDolar, val)
        }
      } else {
        this.porcentaje = 0
      }
    },

    dialog (val) {
      // validar codigo
      this.Productos()
      if (val && this.editedIndex !== -1) this.listarSeriales()
    },
    'form.alto': function (val) {
      if (this.form.alto > 0) {
        this.form.volumen = this.form.alto * this.form.ancho * this.form.largo
      } else {
        this.form.volumen = 0
      }
    },
    'form.ancho': function (val) {
      if (this.form.ancho > 0) {
        this.form.volumen = this.form.alto * this.form.ancho * this.form.largo
      } else {
        this.form.volumen = 0
      }
    },
    'form.largo': function (val) {
      if (this.form.largo > 0) {
        this.form.volumen = this.form.alto * this.form.ancho * this.form.largo
      } else {
        this.form.volumen = 0
      }
    },
    'bs': function (val) {
      if (val) {
        this.dolar = false
        this.precioMoneda()
        this.form.moneda = 'Bs'
      } else {
        this.dolar = true
        this.precioMoneda()
        this.form.moneda = 'Dolar'
      }
    },
    'dolar': function (val) {
      if (val) {
        this.bs = false
        this.precioMoneda()
        this.form.moneda = 'Dolar'
      } else {
        this.bs = true
        this.precioMoneda()
        this.form.moneda = 'Bs'
      }
    },
    'form.precio': function (val) {
      if (val >= 0) {
        this.precioMoneda()
      } else {
        this.form.precioBs = 0
        this.form.precio = 0
      }
    },
    'form.precioBs': function (val) {
      if (val >= 0) {
        this.precioMoneda()
      } else {
        this.form.precioBs = 0
        this.form.precio = 0
      }
    },
    'bsCosto': function (val) {
      if (val) {
        this.dolarCosto = false
      } else {
        this.dolarCosto = true
      }
    },
    'dolarCosto': function (val) {
      if (val) {
        this.bsCosto = false
      } else {
        this.bsCosto = true
      }
    }
  },
  created () {
    EventBus.$on('actualizacionTasaProducto', data => {
      this.configuracion()
    })
    this.initialize()
    this.configuracion()
  },
  
  methods: {
    initialize () {
      this.config = this.$store.state.config.productos
      this.listarFabricantes()
      this.listarPortafolios()
      this.listarAlmacenes()
      this.cargarIVA()
      this.listarLineas()
      this.listarPresentaciones()
      this.listarUnidadesVenta()
      this.form.imagen.imageName = ''
      this.form.imagen.imageFile = ''
      this.form.imagen.imageUrl = ''
      this.permisosAlmacen = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta === 'Almacen')
      this.permisosFabricante = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta === 'Fabricante')
      this.permisosMarca = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta === 'Marca')
      this.permisosPortafolio = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta === 'Portafolio')
      this.permisosLinea = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta === 'Linea')
    },

    // Permisos
    validarCrearAlmacen () {
      return this.permisosAlmacen?.accion?.includes('Crear')
    },
    validarCrearFabricante () {
      return this.permisosFabricante?.accion?.includes('Crear')
    },
    validarCrearMarca () {
      return this.permisosMarca?.accion?.includes('Crear')
    },
    validarCrearPortafolio () {
      return this.permisosPortafolio?.accion?.includes('Crear')
    },
    validarCrearLinea () {
      return this.permisosLinea?.accion?.includes('Crear')
    },

    // Metodos del Empaque
    resetEmpaque () {
      this.empaq = false
      this.formEmpaque = Object.assign({}, this.defaultEmpaque)
      this.editedIndexEmpaque = -1
    },
    closeShow () {
      this.dialogShow = false
      this.resetEmpaque()
    },
    saveEmpaque () {
      if (this.editedIndexEmpaque > -1) {
        this.form.empaques.splice(this.editedIndexEmpaque, 1, this.formEmpaque)
        this.resetEmpaque()
        this.editedIndexEmpaque = -1
      } else {
        this.preEmp = this.form.empaques.some(empaques => empaques.presentacion === this.formEmpaque.presentacion)
        if (this.preEmp) {
          this.$swal({
            icon: 'error',
            title: 'La presentación ya fue registrada'
          })
        } else if (this.formEmpaque.presentacion === '' || this.formEmpaque.cantidad <= 0) {
          this.$swal({
            icon: 'error',
            title: 'Formulario incompleto',
            text:
              'Por favor verifique y llene todos los campos para continuar'
          })
        } else {
          this.EmpaquesDefault.push(this.formEmpaque.presentacion)
          this.form.empaques.push(this.formEmpaque)
          this.resetEmpaque()
        }
      }
    },
    editEmpaque (item) {
      this.editedIndexEmpaque = this.form.empaques.indexOf(item)
      this.empaq = true
      this.formEmpaque.presentacion = item.presentacion
      this.formEmpaque.cantidad = item.cantidad
      this.form.empaques.slice(this.editedIndexEmpaque, 1)
    },
    deleteEmpaque (item) {
      const index = this.form.empaques.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Está seguro que desea eliminar?',
        text: 'No podras revertir esto',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'Cancelar'
      }).then(result => {
        if (result.value) {
          this.$swal.fire('Borrado!', 'Su registro fue borrado.', 'success')
          this.form.empaques.splice(index, 1)
        }
      })
    },
    validarCantidadEmpaque () {
      if (this.formEmpaque.cantidad < 1) {
        this.$swal({
          icon: 'error',
          title: 'ERROR: La cantidad debe ser positiva'
        })
        this.formEmpaque.cantidad = 0
      }
    },
    // Seleccion de Fabricante
    listarFabricantes () {
      Api.get('fabricante')
        .then(response => {
          this.fabricante = response.data
          this.fabricante.map(data => {
            this.idFabricanteArray.push({
              text: data.nombre,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    listarPresentaciones () {
      Api.get('presentacionProd')
        .then(response => {
          response.data.map(data => {
            this.presentaciones.push({
              text: data.descripcion,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    listarUnidadesVenta () {
      Api.get('unidadVenta')
        .then(response => {
          response.data.map(data => {
            this.undidadesVenta.push({
              text: data.descripcion,
              value: data._id,
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    fabricanteSeleccionado (data) {
      const fabriselec = this.fabricante.find(
        fabriselec => fabriselec._id === data
      )
      this.form.idFabricante = fabriselec._id
      this.idMarcaArray = []
      for (let i = 0; i < fabriselec.marca.length; i++) {
        this.idMarcaArray.push({
          text: fabriselec.marca[i].nombre,
          value: fabriselec.marca[i]._id
        })
      }
    },
    // Seleccion de Portafolio
    listarPortafolios () {
      Api.get('portafolio')
        .then(response => {
          this.portafolio = response.data
          this.portafolio.map(data => {
            this.idPortafolioArray.push({
              text: data.descripcion,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    portafolioSeleccionado (data) {
      const portaselec = this.portafolio.find(
        portaselec => portaselec._id === data
      )
      this.form.codPortafolio = portaselec._id
    },

    // Seleccion de Almacen
    listarAlmacenes () {
      Api.get('almacen')
        .then(response => {
          this.almacenes = response.data
          this.almacenes.map(data => {
            this.idAlmacenArray.push({
              text: data.descripcion,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    almacenSeleccionado (data) {
      const almaselec = this.almacenes.find(
        almaselec => almaselec._id === data)
      this.form.idAlmacen = almaselec
    },

    // Seleccion de IVA
    cargarIVA () {
      Api.get('iva')
        .then(response => {
          this.iva = response.data
          this.iva.map(data => {
            this.idIVAArray.push({
              text: data.descripcion,
              value: data._id,
              valor: data.valor
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    IVASeleccionado (data) {
      const ivaSelec = this.iva.find(ivaSelec => ivaSelec._id === data)
      this.form.idIVA = ivaSelec
    },

    // Seleccion de Lineas (Categoria)
    listarLineas () {
      Api.get('/linea')
        .then(response => {
          this.linea = response.data
          this.linea.map(data => {
            this.idLineaArray.push({
              text: data.descripcion,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    lineaSeleccionada (data) {
      const sub = this.linea.find(sub => sub._id === data)
      this.sublineaArray = []
      for (let i = 0; i < sub.subLinea.length; i++) {
        this.sublineaArray.push(sub.subLinea[i].descripcion)
      }
    },

    /* listarMarcas () {
      Api.get('/marca')
        .then(response => {
          this.marca = response.data
          this.marca.map(data => {
            this.idMarcaArray.push({
              text: data.nombre,
              value: data._id
            })
          })
        })
        .catch(e => {
          console.log('error' + e)
        })
    }, */

    // Metodos para la selección de Logo
    pickFile () {
      this.$refs.image.click()
    },
    onFilePicked (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        let peso = false
        for (let j = 0; j < files.length; j++) {
          if (files[j].size > 4194304) {
            peso = true
          }
        }
        if (peso === false) {
          this.form.imagen.imageName = files[0].name
          if (this.form.imagen.imageName.lastIndexOf('.') <= 0) {
            return
          }
          const fr = new FileReader()
          fr.readAsDataURL(files[0])
          fr.addEventListener('load', () => {
            this.form.imagen.imageUrl = fr.result
            this.form.imagen.imageFile = files[0]
          })
        } else {
          this.$swal.fire(
            'Oops...',
            'Error encontrado, la imagen debe pesar menos de 4MB.',
            'error'
          )
          this.files = []
          this.form.imagen = []
        }
      } else {
        this.form.imagen.imageName = ''
        this.form.imagen.imageFile = ''
        this.form.imagen.imageUrl = ''
      }
    },

    // Seriales
    listarSeriales () {
      Api.get('/serial/' + this.form._id)
        .then(response => {
          this.seriales = response.data
          this.seriales.map(serial => {
            serial.fechaRegistro = this.formato(serial.fechaRegistro)
            if (serial.fechaVenta) serial.fechaVenta = this.formato(serial.fechaVenta)
          })
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    configuracion () {
      Api.get('configuracion')
        .then(response => {
          let t = []
          this.tasa = 0
          t.push(response.data.tasa.tasaDia.valor)
          this.tasa = t[0]
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              //text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    formato (fecha) {
      return fecha.substring(0, 10)
    },

    // Buscar los seriales del producto especifico
    modalSeriales () {
      if (!this.validarBotonSerial()) {
        if (this.editedIndex > -1) {
          if (this.seriales.length === 0) this.seriales.push(-1)
          this.ser2 = true
        } else {
          this.ser = true
        }
      }
    },

    // se trae los seriales del hijo al padre para guardarlo
    guardarSerialesProducto (seriales) {
      this.form.seriales = seriales.seriales
    },

    validarBotonSerial () {
      if (this.form.nombre === '') {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text:
            'Necesita crear un codigo del producto para crear los seriales'
        })
        return true
      }
      return false
    },

    precioMoneda () {
      if (this.tasa > 0) {
        if (this.dolar) {
          this.form.precioBs = this.form.precio * this.tasa
          this.form.precioBs = this.form.precioBs.toFixed(2)
          this.form.precioBs = Number(this.form.precioBs)
        } else if (this.bs) {
          this.form.precio = this.form.precioBs / this.tasa
          this.form.precio = this.form.precio.toFixed(2)
          this.form.precio = Number(this.form.precio)
        }
      } else {
        if (this.dolar) this.form.precioBs = 0
        else if (this.bs) this.form.precio = 0
      }
    },

    calculos (costo, porcentaje) {
      if (this.bsCosto) {
        if (this.tasa > 0) {
          this.form.costoDolar = costo / this.tasa
        } else {
          this.form.costoDolar = 0
        }
      } else {
        if (this.tasa > 0) {
          this.form.costo = costo * this.tasa
        } else {
          this.form.costo = 0
        }
      }

      let utilidad = (porcentaje / 100) * this.form.costo
      this.form.precioBs = utilidad + this.form.costo
    },

    validarSteps () {
      switch (this.e6) {
        case 1:
          if (this.read && this.editedIndex > -1) {
            this.e6 = 2
            break
          } else if ( 
            this.form.nombre === '' || this.form.descripcion === '' || this.form.unidadMedida === '' ||
            this.form.idAlmacen === '' || this.form.idIVA === ''
          ) {
            this.$swal({
              icon: 'error',
              title: 'Formulario incompleto',
              text: 'Por favor verifique y llene todos los campos con * para continuar'
            })
          } else if ((this.config.portafolio && this.config.portafolio.valor) && this.form.codPortafolio === null) {
            this.$swal({
              icon: 'error',
              title: 'Formulario incompleto',
              text: 'Por favor verifique y llene todos los campos con * para continuar'
            })
          } else {
            this.e6 = 2
          }
          break
        case 2:
          if ( (this.read && this.editedIndex > -1) && (!this.config.medidas) ) {
            if ((this.config.idLinea && this.config.idLinea.valor) || (this.config.idFabricante && this.config.idFabricante.valor)) {
              this.e6 = 4
              break
            } else if (!this.config.idLinea && !this.config.idFabricante) {
              this.e6 = 5
              break
            }
          } else if ( (this.read && this.editedIndex > -1) && (this.config.medidas && this.config.medidas.valor) ) {
            this.e6 = 3
            break
          } else if ((this.config.stock && this.config.stock.valor) && (this.form.stock < 0 || this.form.stock === '')) {
            this.$swal({
              icon: 'error',
              title: 'Cantidad(u) Invalida',
              text: 'El campo Cantidad no puede ser negativo, estar vacio o ser cero'
            })
          } else if (this.editedIndex < 0 &&
            (this.form.costo === '' ||
            this.form.costo < 0 ||
            this.form.costo > this.form.precioBs)
          ) {
            this.$swal({
              icon: 'error',
              title: 'Costo del Producto Invalido',
              text: 'El costo no puede ser cero, negativo, mayor que el precio o estar vacio'
            })
          } else if (this.editedIndex >= 0 &&
            (this.form.costo === '' ||
            this.form.costo <= 0)
          ) {
            this.$swal({
              icon: 'error',
              title: 'Costo del Producto Invalido',
              text: 'El costo no puede ser cero, negativo o estar vacio'
            })
          } else if (this.config.stockMin.valor && (this.form.stockMin <= 0 || this.form.stockMin === '')) {
            this.$swal({
              icon: 'error',
              title: 'Stock Minino del Producto Invalido',
              text: 'El Stock no puede ser negativo, estar vacio o ser cero'
            })
          } else if ((this.config.peso && this.config.peso.valor) && (this.form.peso < 0 || this.form.peso === '')) {
            this.$swal({
              icon: 'error',
              title: 'Peso del Producto Invalido',
              text: 'El Peso no puede ser negativo, estar vacio o ser cero'
            })
          } else if (!this.config.medidas) {
            if ((this.config.idLinea && this.config.idLinea.valor) || (this.config.idFabricante && this.config.idFabricante.valor)) {
              this.e6 = 4
            } else if (!this.config.idLinea && !this.config.idFabricante) {
              this.e6 = 5
            }
          } else if ((this.config.medidas && this.config.medidas.valor)) {
            this.e6 = 3
          }
          break
        case 3:
          if ( (this.read && this.editedIndex > -1) && ((this.config.idLinea && this.config.idLinea.valor) || (this.config.idFabricante && this.config.idFabricante.valor))) {
            this.e6 = 4
            break
          } else if ( (this.read && this.editedIndex > -1) && (!this.config.idLinea && !this.config.idFabricante)) {
            this.e6 = 5
            break
          }
          else if (
            (this.config.medidas && this.config.medidas.valor) && (
              this.form.largo === '' || this.form.largo <= 0 ||
              this.form.alto === '' || this.form.alto <= 0 ||
              this.form.ancho === '' || this.form.ancho <= 0
            )
          ) {
            this.$swal({
              icon: 'error',
              title: 'Medidas del Producto Invalidas',
              text: 'Las medidas no pueden ser 0, negativo o estar vacio'
            })
          } else if (!this.config.idLinea && !this.config.idFabricante) {
            this.e6 = 5
          }
          else if ((this.config.idLinea && this.config.idLinea.valor) || (this.config.idFabricante && this.config.idFabricante.valor)) {
            this.e6 = 4
          }
          break
        case 4:
          if (this.read && this.editedIndex > -1) {
            this.e6 = 5
            break
          } else if (
            ((this.config.idLinea && this.config.idLinea.valor) && this.form.idLinea === null /* || this.form.sublinea === null */) /* ||
            (this.config.idFabricante.valor && (this.form.idFabricante === null || this.form.idMarca === null)) */
          ) {
            this.$swal({
              icon: 'error',
              title: 'Formulario incompleto',
              text: 'Por favor verifique y llene todos los campos para continuar'
            })
          } else {
            this.e6 = 5
          }
          break
        case 5:
          this.e6 = 6
          break
        case 6:
          this.save()
          break
      }
    },

    Productos () {
      Api.get('/producto')
        .then(res => {
          this.productos = res.data
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    validarCodigo (cod) {
      if (this.productos && this.productos.length > 0) {
        this.codVal = this.productos.some(productos => productos.nombre === cod)
        if (this.codVal) {
          this.$swal({
            icon: 'error',
            title: 'El Codigo de Producto ya existe'
          })
          return true
        }
        return false
      } else {
        return false
      }
    },

    // Cerrar y Guardar
    close () {
      this.img = ''
      this.porcentaje = ''
      this.selecIva = ''
      this.selecAlma = ''
      this.dolarCosto = false
      this.bsCosto = true
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultForm)
        this.e6 = 1
      }, 300)
      // pone el dialog del padre en false
      this.$emit('close')
    },

    save () {
      this.$swal({
        title: 'Cargando...',
        html: 'Esperando respuesta del servidor',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          this.$swal.showLoading()
        }
      })
      delete this.form._id
      this.loading = true
      const data = new FormData()
      Object.keys(this.form).map(key => {
        if (Array.isArray(this.form[key])) {
          this.form[key].forEach(val => {
            if (typeof val === 'object' && val !== null) {
              return data.append(`${key}[]`, JSON.stringify(val))
            }
            return data.append(`${key}[]`, val)
          })
        } else if (
          typeof this.form[key] === 'object' &&
          this.form[key] !== null
        ) {
          return data.append(key, JSON.stringify(this.form[key]))
        } else {
          return data.append(key, this.form[key])
        }
      })
      if (this.form.imagen.imageFile) {
        data.append('imagen', this.form.imagen.imageFile)
      }
      if (this.editedIndex > -1) {
        data.append('_id', this.FormPadre._id)
        Api.put('/producto', data)
          .then(response => {
            this.$swal({
              icon: 'success',
              title: 'Modificacion exitosa',
              text: 'Todos los cambios han sido efectuados'
            })
            this.$emit('edited', this.form)
            this.$emit('editedSer', this.form)
            this.close()
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al modificar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message)
            }
          })
      } else {
        if (
          !this.validarCodigo(this.form.nombre)
        ) {
          Api.post('producto/image', data)
            .then(response => {
              this.$swal({
                icon: 'success',
                title: 'Inclusion exitosa',
                text: 'Todos los datos han sido guardados'
              })
              this.$emit('save', this.form)
              this.$emit('saveSer', this.form)
              this.close()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        }
      }
    }
  }
}
</script>
<style lang="scss">
.actTasa {
  color: #000 !important;
}
 @media screen and (max-width: 375px) {
    .stepper-header {
      .divider-none {
        display: none;
      }
      .v-stepper__step {
        padding: 5px;
      }
    }
    .btn-flex {
      .v-btn {
        height: 30px;
        span {
          font-size: 11px;
        }
      }
    }
    .btn-seriales {
      margin: 20px 0;
      span {
        font-size: 12px;
      }
    }
    .img-pro {
      padding: 20px 0;
    }
  }
</style>
